import React from 'react';

import BaseElement from '../base';
import InlineChromiumBugfix from '../link/inline-chromium-bug-fix';

import './index.scss';

function Divider(props) {

  function renderMain() {

    const dividerBlockAttributes = {
      className: 'divider-block',
      contentEditable: false
    };

    return <div {...dividerBlockAttributes}>
      <InlineChromiumBugfix />
      <div className="divider-element"></div>
      <InlineChromiumBugfix />
      {props.children}
    </div>;

  }

  return <BaseElement {...props} className="divider-block-wrapper" contentEditable={false}>
    {renderMain()}
  </BaseElement>;

}

export default Divider;